import React from 'react';

import DatePickerInput from 'components/DatePickerInput';
import AbstractForm    from 'components/AbstractForm';

export default class ShowForm extends AbstractForm {

  closedChanged = (e) => {
    this.propertyChanged({target: {name: 'closed', type: 'checkbox', checked: !e.target.checked}});
  }

  renderFields() {
    const { item } = this.state;
    return [
        <div className="row" key="name">
          <div className="col-sm-12 mb-3">
            <label htmlFor="name">Название</label>
            <input id="name" name="name" className="form-control" value={item.name} onChange={this.propertyChanged} />
          </div>
        </div>
      ,
        <div className="row" key="starts_at">
          <div className="col-sm-12 mb-3">
            <label htmlFor="starts_at">Дата выставки</label>
            <div>
              <DatePickerInput
                selected={item.starts_at}
                name="starts_at"
                onChange={this.propertyChanged}
              />
            </div>
          </div>
        </div>
      ,
        <div className="row" key="closed">
          <div className="col-sm-12 mb-3">
            <label>Регистрация</label>
            <div className="custom-control custom-switch">
              <input type="checkbox" name="closed" checked={!item.closed} onChange={this.closedChanged} 
                className="custom-control-input" id="closedSwitch" />
              <label className="custom-control-label" htmlFor="closedSwitch">{item.closed ? 'Закрыта' : 'Открыта'}</label>
            </div>
          </div>
        </div>
      ,
        <div className="row" key="description">
          <div className="col-sm-12 mb-3">
            <label htmlFor="description">Описание</label>
            <textarea id="description" name="description" className="form-control" value={item.description || ''} onChange={this.propertyChanged} />
          </div>
        </div>
    ];
  }

}